module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Ack#fm-1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Intro#fm-2"
    }
  }, [_c('em', [_vm._v("Introduction: Defining Evangelicals in a Christian Bookstore")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#ch-1"
    }
  }, [_c('em', [_vm._v("1."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Romance of Abundant Life")])]), _c('br'), _vm._v("Janette Oke’s "), _c('em', [_vm._v("Love Comes Softly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Spiritual Warfare in Everyday America")])]), _c('br'), _vm._v("Frank Peretti’s "), _c('em', [_vm._v("This Present Darkness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Rapture Dilemma")])]), _c('br'), _vm._v("Tim LaHaye and Jerry Jenkins’s "), _c('em', [_vm._v("Left Behind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Authenticity in Amish Bonnets")])]), _c('br'), _vm._v("Beverly Lewis’s "), _c('em', [_vm._v("The Shunning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Amid Emerging Ambiguities")])]), _c('br'), _vm._v("William Paul Young’s "), _c('em', [_vm._v("The Shack")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Conclusion#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conclusion: The Question That Remains")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Endnotes#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0